import Stack from '@mui/material/Stack'
import type { StackProps } from '@mui/material/Stack'
import React from 'react'

const StackComponent: React.FC<StackProps> = (props) => {
  return <Stack {...props} />;
};

export default StackComponent